import { Flex, Typography } from "antd";
import React from "react";
import {
  StyledAppSideBarFooter,
  StyledAppSidebarFooterInfo,
} from "./index.styled";
import { useAuthUser } from "_hooks";
import { AppLogoutIcon } from "_lib/AppIcons";
import AppAvatar from "_lib/AppAvatar";

const AppSidebarFooter = () => {
  const { user } = useAuthUser();

  return (
    <StyledAppSideBarFooter
      vertical
      gap={32}
      align="center"
      justify="space-between"
    >
      <Flex
        className="app-sidebar-footer-container"
        gap={8}
        align="center"
        justify="space-between"
      >
        <Flex gap={16}>
          <AppAvatar />
          <StyledAppSidebarFooterInfo vertical justify="space-between">
            <Text ellipsis>{user?.fullName}</Text>
            <Text ellipsis type="secondary">
              {user?.email}
            </Text>
          </StyledAppSidebarFooterInfo>
        </Flex>

        <AppLogoutIcon isActionable={true} />
      </Flex>
    </StyledAppSideBarFooter>
  );
};

const { Text } = Typography;

export default AppSidebarFooter;
